import { Grid } from "@mui/material";
import ThemeButton from "components/Buttons/ThemeButton";
import styled, { CSSProperties } from "styled-components";
import { blink, shine } from "./animations";

export const DripOfferContainer = styled.div<{ largeTicket: string }>`
	position: relative;
	paint-order: stroke fill;
	font-size: clamp(8px, 2.6vw, 20px);

	h3 {
		color: #fff;
		font-family: "Baloo";
		font-size: 1.5em;
		font-weight: 400;
		margin: 0.1em 0;
		text-shadow: 0.06em 0.06em 0 #000;
		-webkit-text-stroke-width: 0.1em;
		-webkit-text-stroke-color: #000;

		&.mobile {
			color: #5d2904;
			text-align: center;
			line-height: 1em;
		}

		&.isPopup {
			@media (orientation: portrait) {
				color: #5d2904;
				text-shadow: none;
			}
		}

		@media (min-width: 600px) {
			font-size: 1.2em;
		}
		@media (min-width: 900px) {
			font-size: 1.4em;
		}

		@media (max-width: 599px) {
			&.mobile {
				text-shadow: none;
				-webkit-text-stroke-width: 0;
			}
		}
	}

	.ticket {
		background-image: url(${(props) => props.largeTicket});
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: center;
		padding: 1em 6em;

		.item-background {
			position: absolute;
			border-radius: 0.5em;
			opacity: 0.2;
			background: #d98883;
			width: 100%;
			height: 100%;
		}

		@media (min-width: 600px) {
			padding: 0.6em 6em;
		}
		@media (min-width: 900px) {
			padding: 1em 6em;
		}

		@media (max-width: 599px) {
			padding: 1em 2em;
		}
	}

	.item-content {
		display: flex;
		justify-content: center;
		align-items: center;
		position: relative;

		&.small {
			height: 7em;
			top: 0.4em;

			img {
				max-width: 80%;
				max-height: 80%;

				@media (min-width: 600px) {
					max-width: 75%;
					max-height: 70%;
				}
			}
		}

		&.large {
			height: 5.3em;

			@media (min-width: 600px) {
				height: 3.8em;
			}
			@media (min-width: 900px) {
				height: 5.3em;
			}
			img {
				height: 85%;
			}
		}

		p {
			position: absolute;
			right: 0;
			color: #fff;
			font-family: "Baloo";
			font-size: 2em;
			line-height: 1em;
			margin: 0;
			text-shadow: 0.06em 0.06em 0 #000;
			-webkit-text-stroke-width: 0.1em;
			-webkit-text-stroke-color: #000;

			&.small {
				bottom: 0.4em;
				right: 0.2em;

				&.is-large-number {
					font-size: 1.6em;
					bottom: 0.6em;

					@media (min-width: 600px) {
						font-size: 1em;
						bottom: 1.5em;
					}
					@media (min-width: 900px) {
						font-size: 1.1em;
						bottom: 1.4em;
					}
				}

				@media (min-width: 600px) {
					bottom: 1em;
					right: 0.3em;
				}
			}

			&.large {
				bottom: 0;
				right: 0;

				@media (min-width: 900px) {
					bottom: 0.15em;
				}
			}

			&.is-coin {
				right: 50%;
				transform: translateX(50%);
			}

			@media (min-width: 600px) {
				font-size: 1.4em;
			}
		}
	}

	.plus {
		font-family: "Baloo";
		font-size: 2.8em;
		color: white;
		text-shadow: 0.06em 0.06em 0 #000;
		-webkit-text-stroke-width: 0.1em;
		-webkit-text-stroke-color: #000;

		@media (min-width: 600px) {
			font-size: 2em;
		}
		@media (min-width: 900px) {
			font-size: 2.8em;
		}
	}

	.sale-info {
		height: 100%;
		background-image: url(${(props) => props.largeTicket});
		background-size: 100% 100%;
		background-repeat: no-repeat;
		background-position: center;
		padding: 2.4em 0.625em 0.8em;

		p {
			text-align: center;
			color: #f8f3e4;
			font-family: "Baloo";
			font-size: 1em;
			margin: 0;
			line-height: 100%;

			@media (max-width: 599px) {
				&.title {
					color: #5d2904;
					text-align: left;
					line-height: 75%;
					font-size: 1.2em;
				}
			}
		}

		.red-x {
			position: relative;
			width: 1.6em;
			height: 1.6em;

			@media (min-width: 600px) {
				width: 1.2em;
				height: 1.2em;
			}
		}

		@media (max-width: 599px) {
			padding: 3em 1em 0.8em;
		}
	}
`;

export const RedX = styled.div`
	position: absolute;
	top: 0;
	animation: ${blink} 0.5s infinite;
	animation-iteration-count: 3;
	width: 100%;
	height: 100%;
`;

export const SmallTicket = styled(Grid)<{
	background: string;
	claimed: string;
	ispopup?: string;
}>`
	background-image: url(${(props) => props.background});
	background-size: 100% 100%;
	background-repeat: no-repeat;
	background-position: center;
	opacity: ${(props) => (props.claimed === "true" ? 0.5 : 1)};

	p {
		margin: 0;

		&.prize-name {
			position: relative;
			top: ${(props) => (props.ispopup ? 0 : "0.2em")};
			display: flex;
			align-items: center;
			justify-content: center;
			color: #5d2904;
			text-align: center;
			font-family: "Baloo";
			font-size: ${(props) => (props.ispopup === "true" ? "16px" : "1.6em")};
			text-transform: capitalize;

			@media (min-width: 600px) {
				font-size: ${(props) => (props.ispopup === "true" ? "16px" : "1.2em")};
			}
		}
	}
`;

export const ClaimedSmallTicket = styled.img`
	position: absolute;
	top: 45%;
	left: 55%;
	transform: translate(-50%, -50%);
	width: 80%;
	z-index: 1;
`;

export const Shine = styled.img`
	position: absolute;
	top: 45%;
	left: 54%;
	width: 140%;
	opacity: 0.8;
	animation: ${shine} 60s linear infinite;
`;

export const TopBrush = styled.div`
	overflow: hidden;
	width: 100%;
	position: absolute;
	top: -53px;
	left: 0;
	z-index: 1;

	> img {
		width: 100%;
	}

	@media (min-width: 900px) {
		top: -86px;
	}
`;

export const Background = styled.div<{
	background: string;
	firstBackground: boolean;
}>`
	position: absolute;
	left: 0;
	background-image: url(${(props) => props.background});
	background-position: center center;
	background-size: 100% 100%;
	background-repeat: no-repeat;
	width: 100%;
	z-index: 0;
	background-size: cover;
	top: -85px;
	aspect-ratio: 2015 / 524;

	@media (max-width: 899px) {
		top: -52px;
	}

	@media (max-width: 599px) {
		aspect-ratio: 376 / 282;
	}
`;

export const Title = styled.img`
	width: 12em;
	margin-top: 3.2em;

	@media (min-width: 600px) {
		margin-top: 0;
	}
	@media (min-width: 900px) {
		width: 16em;
	}
`;

export const Button = styled(ThemeButton)`
	max-width: 329px;
	width: 100%;
	font-size: 1.6em;

	@media (min-width: 600px) {
		font-size: 1.3em;
	}
`;

export const InfoButton = styled.button`
	position: absolute;
	top: 1%;
	right: 0;
	background: none;
	border: none;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;

	&.is-small {
		top: 95%;
		right: 100%;
		transform: translate(95%, -100%);
	}

	&.is-popup {
		right: -0.5em;
	}
`;

export const Tiki = styled.img<{ isPopup?: boolean }>`
	position: absolute;
	top: ${(props) => (props.isPopup ? "-62px" : "-4.7em")};
	width: ${(props) => (props.isPopup ? "95px" : "7em")};
	right: 0;

	@media (max-width: 599px) {
		transform: rotateY(180deg);
		left: ${(props) => (props.isPopup ? "80%" : "0.5em")};
	}
`;

export const SmallTicketTiki = styled.img<{ isPopup?: boolean }>`
	position: absolute;
	top: ${(props) => (props.isPopup ? "-55px" : "-4.7em")};
	right: 50%;
	transform: translateX(50%);
	width: ${(props) => (props.isPopup ? "95px" : "8.3em")};
	z-index: 1;

	@media (min-width: 600px) {
		top: -2.8em;
		width: 5em;
	}
`;

export const timerStyle: CSSProperties = {
	fontSize: "0.8em",
	position: "absolute",
	padding: "0.3em 0.7em",
	top: 0,
	left: 0
};

export const timerStyleMobile: CSSProperties = {
	...timerStyle,
	fontSize: "1em"
};

export const LoyaltyPoints = styled.div`
	font-size: clamp(12px, 2.8vw, 16px);
	border-radius: 15px;
	background: rgba(0, 0, 0, 0.5);
	font-family: "Inter";
	font-weight: 700;
	line-height: 0.875em;
	color: white;
	padding: 0.5em 0.8em;

	> div {
		align-items: center;
		justify-content: center;
		display: flex;
		gap: 0.2rem;
	}

	&.isPoisActive {
		font-size: 0.625em;
		padding: 0.1em 0.8em 0.3em;
	}
`;
